<template>
    <div ref="root">
        <app-modulebackground
            :module-id="module.id"
            custom-class="openingtimes__background module__background"
        >
        </app-modulebackground>
        <div
            class="openingtimes__container module__container"
            v-bind:class="{
                container__boxed: [1, 2].includes(module.layout.type),
                container__fluid: [3, 4].includes(module.layout.type),
                'container__boxed--half': [5, 6].includes(module.layout.type)
            }"
        >
            <div class="openingtimes__inner module__inner">
                <div
                    class="openingtimes__inner--main module__inner--main"
                    v-bind:class="{
                        'calc-padding--left': [3].includes(module.layout.type),
                        'calc-padding--right': [4].includes(module.layout.type)
                    }"
                >
                    <div
                        class="openingtimes__inner-row module__inner-row"
                        v-if="module.data.title || module.data.subtitle"
                    >
                        <div class="openingtimes__inner-col module__inner-col">
                            <div class="openingtimes__header module__header">
                                <h2
                                    class="openingtimes__title module__title font-h2 color-h2"
                                    v-if="module.data.title"
                                    v-html="module.data.title"
                                ></h2>
                                <h3
                                    class="openingtimes__subtitle module__subtitle font-h3 color-h3"
                                    v-if="module.data.subtitle"
                                    v-html="module.data.subtitle"
                                ></h3>
                            </div>
                        </div>
                    </div>
                    <div class="openingtimes__inner-row module__inner-row">
                        <div class="openingtimes__inner-col module__inner-col">
                            <div class="openingtimes__content-block module__content-block">
                                <div
                                    class="openingtimes__content-block--left module__content-block--left"
                                    v-bind:class="{
                                        'col__width--full': [1, 2, 3, 4].includes(
                                            module.layout.type
                                        ),
                                        'col__width--half': [5, 6].includes(module.layout.type)
                                    }"
                                    v-if="
                                        module.data.text ||
                                            ([5, 6].includes(module.layout.type) &&
                                                ((module.data.link && module.data.link.active) ||
                                                    (module.data.link2 &&
                                                        module.data.link2.active) ||
                                                    (module.data.link3 &&
                                                        module.data.link3.active)))
                                    "
                                >
                                    <div
                                        class="openingtimes__inner-row module__inner-row"
                                        v-if="module.data.text"
                                    >
                                        <div class="openingtimes__inner-col module__inner-col">
                                            <div
                                                class="openingtimes__text module__text font-p color-p module__cms"
                                                v-if="module.data.text"
                                                v-html="module.data.text"
                                            ></div>
                                        </div>
                                    </div>
                                    <div
                                        class="openingtimes__inner-row module__inner-row"
                                        v-if="
                                            [5, 6].includes(module.layout.type) &&
                                                ((module.data.link && module.data.link.active) ||
                                                    (module.data.link2 &&
                                                        module.data.link2.active) ||
                                                    (module.data.link3 && module.data.link3.active))
                                        "
                                    >
                                        <div class="openingtimes__inner-col module__inner-col">
                                            <div class="openingtimes__cta module__cta">
                                                <app-modulebutton
                                                    v-if="[5, 6].includes(module.layout.type)"
                                                    :data="module.data.link"
                                                    :custom-class="
                                                        'openingtimes__cta-btn module__cta-btn font-button color-button bg-color-button'
                                                    "
                                                >
                                                </app-modulebutton>
                                                <app-modulebutton
                                                    v-if="[5, 6].includes(module.layout.type)"
                                                    :data="module.data.link2"
                                                    :custom-class="
                                                        'openingtimes__cta-btn module__cta-btn font-button color-button bg-color-button'
                                                    "
                                                >
                                                </app-modulebutton>
                                                <app-modulebutton
                                                    v-if="[5, 6].includes(module.layout.type)"
                                                    :data="module.data.link3"
                                                    :custom-class="
                                                        'openingtimes__cta-btn module__cta-btn font-button color-button bg-color-button'
                                                    "
                                                >
                                                </app-modulebutton>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="openingtimes__content-block--right module__content-block--right"
                                    v-bind:class="{
                                        'col__width--full': [1, 2, 3, 4].includes(
                                            module.layout.type
                                        ),
                                        'col__width--half': [5, 6].includes(module.layout.type)
                                    }"
                                    v-if="openingtimes"
                                >
                                    <div class="openingtimes__inner-row module__inner-row">
                                        <div class="openingtimes__inner-col module__inner-col">
                                            <div class="openingtimes__days">
                                                <ul class="openingtimes__days-list module__list">
                                                    <li
                                                        class="openingtimes__days-item module__list-item"
                                                        v-bind:class="{
                                                            'col__width--one-third ': [
                                                                1,
                                                                2
                                                            ].includes(module.layout.type),
                                                            'col__width--half': [3, 4].includes(
                                                                module.layout.type
                                                            )
                                                        }"
                                                        v-for="(openingtimes__value,
                                                        openingtimes__key) in openingtimes"
                                                        v-bind:key="openingtimes__key"
                                                    >
                                                        <span
                                                            class="openingtimes__days-item-label font-bold"
                                                            >{{ openingtimes__key }}</span
                                                        >
                                                        <template
                                                            v-if="openingtimes__value.length === 0"
                                                        >
                                                            <div
                                                                class="openingtimes__days-item-times"
                                                            >
                                                                geschlossen
                                                            </div>
                                                        </template>
                                                        <template v-else>
                                                            <ul
                                                                class="openingtimes__days-item-times"
                                                            >
                                                                <li
                                                                    v-for="openingtimes__value__value in openingtimes__value"
                                                                    v-bind:key="
                                                                        openingtimes__value__value
                                                                    "
                                                                >
                                                                    {{ openingtimes__value__value }}
                                                                </li>
                                                            </ul>
                                                        </template>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="openingtimes__inner-row module__inner-row"
                        v-if="
                            [1, 2, 3, 4].includes(module.layout.type) &&
                                ((module.data.link && module.data.link.active) ||
                                    (module.data.link2 && module.data.link2.active) ||
                                    (module.data.link3 && module.data.link3.active))
                        "
                    >
                        <div class="openingtimes__inner-col module__inner-col">
                            <div class=" openingtimes__cta module__cta">
                                <app-modulebutton
                                    v-if="[1, 2, 3, 4].includes(module.layout.type)"
                                    :data="module.data.link"
                                    :custom-class="
                                        'openingtimes__cta-btn module__cta-btn font-button color-button bg-color-button'
                                    "
                                >
                                </app-modulebutton>
                                <app-modulebutton
                                    v-if="[1, 2, 3, 4].includes(module.layout.type)"
                                    :data="module.data.link2"
                                    :custom-class="
                                        'openingtimes__cta-btn module__cta-btn font-button color-button bg-color-button'
                                    "
                                >
                                </app-modulebutton>
                                <app-modulebutton
                                    v-if="[1, 2, 3, 4].includes(module.layout.type)"
                                    :data="module.data.link3"
                                    :custom-class="
                                        'openingtimes__cta-btn module__cta-btn font-button color-button bg-color-button'
                                    "
                                >
                                </app-modulebutton>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    class="openingtimes__inner--image module__inner--image"
                    v-if="
                        [3, 4].includes(module.layout.type) &&
                            module.data.image &&
                            module.data.image.id
                    "
                >
                    <app-moduleimage
                        v-if="[3, 4].includes(module.layout.type)"
                        :data="module.data.image"
                        :tag="'div'"
                        :custom-class="'openingtimes__moduleimage module__moduleimage'"
                    >
                    </app-moduleimage>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ModuleButton from '@/components/assorted/ModuleButton';
import ModuleImage from '@/components/assorted/ModuleImage';
import ModuleBackground from '@/components/assorted/ModuleBackground';

export default {
    data() {
        return {};
    },
    components: {
        'app-modulebutton': ModuleButton,
        'app-moduleimage': ModuleImage,
        'app-modulebackground': ModuleBackground
    },
    methods: {},
    computed: {
        ...mapGetters(['getProp', 'generateMediaUrl']),
        openingtimes() {
            let days = {
                Montag: [],
                Dienstag: [],
                Mittwoch: [],
                Donnerstag: [],
                Freitag: [],
                Samstag: []
            };
            let openingtimes = this.getProp('deha.user.misc.openingtimes');
            if (openingtimes === undefined || openingtimes === null || openingtimes === '') {
                return days;
            }
            Object.keys(days).forEach((days__key) => {
                Object.values(openingtimes).forEach((openingtimes__value) => {
                    if (days__key === openingtimes__value.day) {
                        days[days__key].push(
                            openingtimes__value.from + ' – ' + openingtimes__value.until + ' Uhr'
                        );
                    }
                });
            });
            return days;
        }
    },
    props: {
        module: Object
    },
    mounted() {}
};
</script>
